import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { getMaterialClassification, selectScrapItems } from "../../../redux/action/classificationScrap";

function SelectScrapMaterial() {
    const dispatch = useDispatch();
    const { scrapLoading, scarpItem } = useSelector(
        (state) => state.materialClassifications
    );
    const [accountSetupCompleted, setAccountSetupCompleted] = useState(false);
    const [selectedScarpItem, setselectedScarpItem] = useState([]);

    const handleSelectScarp = (item) => {
        const updatedScrap = selectedScarpItem?.map((scrap) => {
            if (scrap._id === item._id) {
                return { ...scrap, selected: !scrap.selected };
            }
            return scrap;
        });
        setselectedScarpItem(updatedScrap);
    };

    const checkScrapSelected = () => {
        return !selectedScarpItem?.some((scrap) => scrap?.selected);
    };

    const handleAddScrap = async () => {
        const scrapIdList = await selectedScarpItem
            .filter((obj) => obj?.selected)
            ?.map((obj) => obj?._id);

        dispatch(selectScrapItems(scrapIdList, setAccountSetupCompleted));
    };
    useEffect(() => {
        dispatch(getMaterialClassification());
    }, [dispatch]);

    useEffect(() => {
        if (accountSetupCompleted) {
            window.location.href = "/"
        }
    }, [accountSetupCompleted]);

    useEffect(() => {
        setselectedScarpItem(scarpItem);
    }, [scarpItem]);

    return (
        <div>
            <div className="valign-wrapper flex-wrap gap-1">
                {selectedScarpItem?.map((item) => (
                    <span
                        className={`valign-wrapper justify-center gap-1 pointer`}
                        key={item?._id}
                        style={{
                            border: item?.selected
                                ? "1px solid #6f2da8"
                                : "1px solid #e7e7e7",
                            padding: "8px 20px",
                            borderRadius: "22px",
                            backgroundColor: item?.selected ? "#6f2da8" : "white",
                        }}
                        onClick={() => handleSelectScarp(item)}
                    >
                        <p
                            className={`font-16px ${item?.selected ? "white-text" : "cercle-purple-text"
                                }`}
                        >
                            {item?.materialClassification}
                        </p>
                    </span>
                ))}
            </div>
            <div
                className="full-width mt-4"
                style={{
                    height: "6px",
                    borderRadius: "16px",
                    backgroundImage:
                        "linear-gradient(to right, white,white,#6F2DA8,#4F068D,#4F068D)",
                }}
            ></div>
            <p className="flex justify-end mt-2">
                <button
                    className="button-style pointer font-weight-600 font-16px font-cercular-bold"
                    style={{
                        padding: "10px 25px",
                        backgroundColor: checkScrapSelected() ? "#e0e0e0" : "#6f2da8",
                        color: !checkScrapSelected() && "#e0e0e0",
                    }}
                    disabled={checkScrapSelected()}
                    onClick={handleAddScrap}
                >
                    {scrapLoading ? <ClipLoader color="red" size={20} /> : "Submit"}
                </button>
            </p>
        </div>
    );
}

export default SelectScrapMaterial;
